import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProductBuyPage.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ProductBuyPage = ({ products, onAddToCart }) => {
  const { id } = useParams();
  const imageUrl = `/product-${id}.png`;

  const navigate = useNavigate();
  const product = products.find((p) => p.id === parseInt(id));
  const [quantity, setQuantity] = useState(1);

  if (!product) {
    return <div style={{ padding: "2rem" }}>Product not found!</div>;
  }

  const handleAddToCart = () => {
    if (onAddToCart) {
      onAddToCart({ ...product, quantity });
    }
  };

  const handleBuyNow = () => {
    // handleAddToCart();
    navigate("/checkout", {
      state: {
        productId: product.id,
        productName: product.name,
        quantity: quantity,
      },
    });
  };

  return (
    <div className={"product-buy-wrapper"}>
      <div className="product-buy-container">
        <div className="product-buy-back">
          <button
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: "#f0f0f0",
              color: "black",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              border: "none",
            }}
            onClick={() => navigate("/")}
          >
            <ArrowBackIcon />
          </button>
        </div>
        <div className="product-buy-content">
          <div
            className="product-buy-image"
            style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="product-buy-details">
            <h1 className="product-buy-title">{product.name}</h1>
            <p className="product-buy-price">₹{product.price}</p>
            <p className="product-buy-description">{product.description}</p>
            <div className="product-buy-quantity">
              <label htmlFor="quantity">Quantity:</label>
              <input
                id="quantity"
                type="number"
                min="1"
                value={quantity}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "") {
                    setQuantity("");
                  } else {
                    const num = parseInt(val, 10);
                    if (!isNaN(num) && num > 0) {
                      setQuantity(num);
                    }
                  }
                }}
                onBlur={() => {
                  if (!quantity || quantity < 1) setQuantity(1);
                }}
              />
            </div>
            <div className="product-buy-buttons">
              <button
                className="product-buy-cart"
                onClick={handleAddToCart}
                disabled={true}
              >
                Add to Cart
              </button>
              <button className="product-buy-buy" onClick={handleBuyNow}>
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductBuyPage;
